import { cloneDeep } from 'lodash';

const _ = { cloneDeep };

const initialState = {
    isLoading: false,
    listType: null,
    id: null,
    gender: null,
    savedItem: null,
    savedLists: [],
    isCreatingList: false,
    listCreationfailed: false,
    errorMessage: '',
    creatingListName: '',
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'MANAGE_LISTS:SAVE':
            return {
                ...state,
                isLoading: true,
            };
        case 'MANAGE_LISTS:SAVE_FAILED':
            return {
                ...state,
                isLoading: false,
            };
        case 'MANAGE_LISTS:SAVE_SUCCESS':
            return {
                ...state,
                isLoading: false,
            };
        case 'MANAGE_LISTS:FETCH_SAVED_LIST':
            return {
                ...state,
                isLoading: true,
            };
        case 'MANAGE_LISTS:FETCH_SAVED_LIST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'MANAGE_LISTS:FETCH_SAVED_LIST_SUCCESS':
            return {
                ...state,
                isLoading: false,
            };
        case 'MANAGE_LISTS:ADD_TYPE_ID':
            return {
                ...state,
                listType: action.data.listType,
                id: action.data.id,
                gender: action.data.gender,
            };
        case 'MANAGE_LISTS:SAVE_PROCESSED_DATA':
            return {
                ...state,
                savedItem: action.data.savedItem,
                savedLists: action.data.savedLists,
            };
        case 'MANAGE_LISTS:UPDATE_SAVED_LIST':
            return {
                ...state,
                savedLists: _.cloneDeep(action.data.savedLists),
            };
        case 'MANAGE_LISTS:CREATE_LIST':
            return {
                ...state,
                isCreatingList: true,
                listCreationfailed: false,
                errorMessage: '',
                creatingListName: action.data.listname,
            };
        case 'MANAGE_LISTS:CREATE_LIST_FAILURE':
            return {
                ...state,
                isCreatingList: false,
                listCreationfailed: true,
                errorMessage: action.data.errorMessage,
            };
        case 'MANAGE_LISTS:CREATE_LIST_SUCCESS':
            return {
                ...state,
                isCreatingList: false,
                listCreationfailed: false,
                savedLists: _.cloneDeep(action.data.savedLists),
            };
        default:
            return state;
    }
}

export default app;
